import { useState } from "react";
import axios from "axios";
import {
  GET_ORDER_SCHEDULE_STATUS,
  GET_ORDER_SUMMARY,
  GET_RETURN_ORDER_SUMMARY,
  GET_SELLER_ORDERS,
  GET_SELLER_RETURN_ORDERS,
} from "../../apis/configuration";
import { handleApi } from "../../apis";
import { toast } from "react-toastify";
import { mergeJsonArrays } from "../../constants";
import { useNavigate } from "react-router-dom";

/**
 * Custom hook to get suppliers orders
 * @returns orders, order rejection reasoons, orders sttaus count and loading state
 */

const useOrderLines = () => {
  const [loading, setLoading] = useState({
    ordersLoad: true,
    returnLoad: false,
    pageLoad: false,
    searchLoad: false,
  });
  const [returnList, setReturnList] = useState();
  const [orderList, setOrderList] = useState([]);
  const [returnListParams, setReturnListParams] = useState({
    orderStatuses: {},
    totalOrders: 0,
  });
  const [orderListParams, setOrderListParams] = useState({
    rejectReasons: [],
    orderStatuses: {},
    totalOrders: 0,
  });
  const navigate = useNavigate();
  /**
   * Get all order from suppliers
   */

  const handleLoading = () =>
    setLoading({
      ordersLoad: false,
      pageLoad: false,
      returnLoad: false,
      searchLoad: false,
    });

  const handleOrderList = (offset = 0, limit = 15, search, filters, cancelSource) => {
    if (offset > 0) setLoading({ ...loading, pageLoad: true });
    else if (search) setLoading({ ...loading, searchLoad: true });

    return new Promise(async (resolve, reject) => {
      Promise.all(
        offset > 0 || search
          ? [
              handleApi(
                GET_SELLER_ORDERS,
                { offset, limit, keyword: search, ...filters },
                cancelSource,
                navigate,
              ),
            ]
          : [
              handleApi(
                GET_SELLER_ORDERS,
                { offset, limit, keyword: search, ...filters },
                cancelSource,
                navigate,
              ),
              handleApi(GET_ORDER_SUMMARY, null, null, navigate),
            ],
      )
        .then((resp) => {
          const { results, count } = resp[0] || {};
          const { order_count, rejection_reasons } = resp[1] || {};

          setOrderList(offset > 0 ? [...orderList, ...results] : results);
          if (offset == 0 && !search) {
            setOrderListParams({
              rejectReasons: rejection_reasons,
              orderStatuses: order_count,
              totalOrders: count,
            });
          }

          handleLoading();
          resolve();
        })
        .catch((err) => {
          if (axios.isCancel(err)) return;
          handleLoading();
          toast.error(err?.response?.data?.message || "Something went wrong", {
            className: "errorToast",
          });
          reject(err);
        });
    });
  };

  const handleReturnOrderList = (offset = 0, limit = 15, search, filters, cancelSource) => {
    if (offset > 0) setLoading({ ...loading, pageLoad: true });
    else if (search) setLoading({ ...loading, searchLoad: true });
    else setLoading({ ...loading, returnLoad: true });

    return new Promise(async (resolve, reject) => {
      Promise.all(
        offset > 0 || search
          ? [
              handleApi(GET_SELLER_RETURN_ORDERS, {
                offset,
                limit,
                keyword: search,
                ...filters,
              }, cancelSource, navigate),
            ]
          : [
              handleApi(GET_SELLER_RETURN_ORDERS, {
                offset,
                limit,
                keyword: search,
                ...filters,
              }, cancelSource, navigate),
              handleApi(GET_RETURN_ORDER_SUMMARY,null,null,navigate),
            ],
      )
        .then((resp) => {
          const { results, count } = resp[0] || {};
          const { order_count } = resp[1] || {};

          setReturnList(offset > 0 ? [...returnList, ...results] : results);

          if (offset == 0 && !search) {
            setReturnListParams({
              orderStatuses: order_count,
              totalOrders: count,
            });
          }

          handleLoading();
          resolve();
        })
        .catch((err) => {
          if (axios.isCancel(err)) return;
          handleLoading();
          toast.error(err?.response?.data?.message || "Something went wrong", {
            className: "errorToast",
          });
          reject(err);
        });
    });
  };

  const handleOrderStatusList = (params) => {
    return new Promise((resolve, reject) => {
      handleApi(GET_ORDER_SCHEDULE_STATUS, params,null,navigate)
        .then((res) => {
          const { orders_schedule_status } = res || {};

          let updatedList = mergeJsonArrays(
            orderList || [],
            orders_schedule_status || [],
            "id",
          );
          setOrderList(updatedList);

          resolve();
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message || "Something went wrong", {
            className: "errorToast",
          });
          reject(err);
        });
    });
  };

  return {
    handleReturnOrderList,
    returnListParams,
    orderListParams,
    handleOrderList,
    handleOrderStatusList,
    returnList,
    orderList,
    loading,
    setLoading
  };
};

export default useOrderLines;
